import {fetch} from "../../utils/dataAccess";

export function error(error) {
    return {type: "BRAND_LIST_ERROR", error};
}

export function loading(loading) {
    return {type: "BRAND_LIST_LOADING", loading};
}

export function success(retrieved) {
    return {type: "BRAND_LIST_SUCCESS", retrieved};
}

export function brandList(params = "pagination=false&draft=false") {
    return dispatch => {
        fetch(`/brands?${params}`).then(response => {
            response.json().then(retrieved => {
                dispatch(success(retrieved["hydra:member"]));
            })
        }).catch(error => {
            // canceled
        });
    };
}

export function reset() {
    return dispatch => {
        dispatch({type: "BRAND_LIST_RESET"});
        dispatch(loading(false));
        dispatch(error(null));
        dispatch(success(null))
    };
}
